import { ProtocolContentData } from "../../protocol";
export default class BridgeNavigationalWatchAlarmSystem extends ProtocolContentData {
    alarmState;
    freeText;
    constructor(alarmState, freeText) {
        super();
        this.alarmState = alarmState;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=BridgeNavigationalWatchAlarmSystem.js.map